
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./im20.cjs.production.min.js')
} else {
  module.exports = require('./im20.cjs.development.js')
}
